import { getSuper } from '../utilities/object';
const defaultOptionsCollection = new Map();
export function defaultOptions(options) {
    return (target) => {
        defaultOptionsCollection.set(target, options);
    };
}
/**
 *
 * @param instance The instance to check default options for
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const hasDefaultOptions = (instance) => {
    const constructors = [];
    let currentTarget = instance.constructor;
    while (currentTarget) {
        constructors.push(currentTarget);
        currentTarget = getSuper(currentTarget);
    }
    return constructors.some((constructor) => defaultOptionsCollection.has(constructor));
};
/**
 * Looks up and returns the default options for the provided object's inherited parent class (if it exists)
 *
 * @param object The class who's parent's default options will be fetched
 */
// eslint-disable-next-line @typescript-eslint/ban-types
const getParentDefaultOptions = (object) => {
    const parent = getSuper(object);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return parent ? getDefaultOptions(parent) : {};
};
/**
 * Gets the default options that were registered for a provided class (or the class for an instance). This will
 * also find default options for any parent classes and merge them into the returned object
 *
 * @param instanceOrObject A class or an instance of a class to get default options for
 */
export function getDefaultOptions(instanceOrObject) {
    let constructor;
    // Find the actual constructor
    if (typeof instanceOrObject === 'function') {
        constructor = instanceOrObject;
    }
    else if ('constructor' in instanceOrObject) {
        constructor = instanceOrObject.constructor;
    }
    // Get any parent default options
    const parentDefaultOptions = getParentDefaultOptions(constructor);
    // Merge the options, with the child default options overriding the parent default options
    return {
        ...parentDefaultOptions,
        ...defaultOptionsCollection.get(constructor),
    };
}
// eslint-disable-next-line @typescript-eslint/ban-types
export const applyDefaultOptions = (instance, options) => ({
    ...getDefaultOptions(instance),
    ...options,
});
export const clearDefaultOptions = () => defaultOptionsCollection.clear();
